import useSWR from 'swr'

import { fetchWithToken } from 'services/fetchers'

import * as T from 'types'

import getErrorMessage from '../utils/getErrorMessage'
import { isServerError } from '../utils/isServerError'

export const useUserListings = () => {
  const key = '/listings/user?sparse=true'
  const response = useSWR<T.ISparseListing[] | T.IServerError>(key, fetchWithToken)

  let listings: T.ISparseListing[] | undefined

  if (response.data && !isServerError(response) && Array.isArray(response.data)) {
    listings = response.data
  }

  const error = getErrorMessage(response, 'listings', true)

  return {
    ...response,
    userListings: listings,
    listings,
    error,
  }
}
